import React, { useState, useContext } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Typography,
  Paper,
} from "@mui/material";
import apiClient from "../../../api/Api.js";
import { DataContext } from "../../../context/dataprovider.js";

const XLDownloadFile = ({ data }) => {
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [payment_type, setpayment_type] = useState("");
  const [vendorname, setvendorname] = useState("");
  const [sender_name, setSenderName] = useState("");

  const { userData } = useContext(DataContext);

  const statusOptions = [
    "Submitted",
    "Approved",
    "Financial Approved",
    "Uploaded to Bank",
    "Partial Payment Done",
    "Payment done,Awaiting for Bills",
    "Bills Quality Hold",
    "Bills Accepted",
    "Denied",
    "Accountant Denied",
    "Financial Admin Denied",
    "Bills Quality failed",
    "Suspended",
  ];

  const projectOptions = userData?.projectId || ["P23", "P27", "P31"];

  const paymentTypes = [
    "General",
    "Material and PO Payment",
    "Site Expenditure",
    "UPI payment",
  ];

  const handleSubmit = async () => {
    if (fromDate && toDate && fromDate > toDate) {
      alert("From Date cannot be greater than To Date");
      return;
    }
    if ((fromDate && !toDate) || (!fromDate && toDate)) {
      alert("Please select both From and To dates");
      return;
    }
    if (selectedProjects.length === 0) {
      alert("Please select min 1 project");
      return;
    }

    const filterData = {
      status: selectedStatus,
      projects: selectedProjects,
      fromDate,
      toDate,
      payment_type,
      vendorname,
      sender_name,
    };

    try {
      const response = await apiClient.post(
        `api/newdata/downloadxl`,
        {
          data: {
            role: userData.role,
            ...filterData,
          },
        },
        { responseType: "blob" }
      );

      if (response.data.type === "application/json") {
        const reader = new FileReader();
        reader.onload = () => {
          const error = JSON.parse(reader.result);
          alert(error.message || "Download failed");
        };
        reader.readAsText(response.data);
        return;
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute(
        "download",
        `transactions-${new Date().toISOString().split("T")[0]}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download error:", error);
      alert(
        error.response?.data?.message || "Download failed. Please try again."
      );
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", py: 4 }}>
      <Paper
        elevation={6}
        sx={{
          width: { xs: "90%", sm: "600px" },
          margin: "auto",
          p: 4,
          borderRadius: 3,
          backgroundColor: "#fff",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            color: "#1976D2",
            fontWeight: "bold",
            mb: 3,
          }}
        >
          Download Filters
        </Typography>

        {/* Status Multi-select */}
        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
          <InputLabel>Status</InputLabel>
          <Select
            multiple
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            input={<OutlinedInput label="Status" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
          >
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                <Checkbox checked={selectedStatus.indexOf(status) > -1} />
                <ListItemText primary={status} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Projects Multi-select */}
        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
          <InputLabel>Projects</InputLabel>
          <Select
            multiple
            value={selectedProjects}
            onChange={(e) => setSelectedProjects(e.target.value)}
            input={<OutlinedInput label="Projects" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
          >
            {projectOptions.map((project) => (
              <MenuItem key={project} value={project}>
                <Checkbox checked={selectedProjects.indexOf(project) > -1} />
                <ListItemText primary={project} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Payment Type Dropdown */}
        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
          <InputLabel>Payment Type</InputLabel>
          <Select
            value={payment_type}
            onChange={(e) => setpayment_type(e.target.value)}
            label="Payment Type"
          >
            <MenuItem value="">All</MenuItem>
            {paymentTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Vendor Name */}
        <TextField
          label="Vendor Name"
          type="text"
          value={vendorname}
          onChange={(e) => setvendorname(e.target.value)}
          size="small"
          fullWidth
          sx={{ mb: 2 }}
        />

        {/* Sender Name */}
        <TextField
          label="Sender Name"
          type="text"
          value={sender_name}
          onChange={(e) => setSenderName(e.target.value)}
          size="small"
          fullWidth
          sx={{ mb: 2 }}
        />

        {/* From Date */}
        <TextField
          label="From Date"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
          fullWidth
          sx={{ mb: 2 }}
        />

        {/* To Date */}
        <TextField
          label="To Date"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
          fullWidth
          sx={{ mb: 3 }}
        />

        {/* Submit Button */}
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={handleSubmit}
          fullWidth
          sx={{
            fontWeight: "bold",
            borderRadius: 2,
            py: 1.5,
            textTransform: "none",
            fontSize: "16px",
          }}
        >
          Download XL
        </Button>
      </Paper>
    </Box>
  );
};

export default XLDownloadFile;
